export default "https://cdn.questicon.mathletics.com/assets/images/Error-e05041220e326c3236596d44780e22e8.svg";